import React from 'react';
import { Link } from 'react-router-dom';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';
//components
import QuoteCarousel from '../components/quote-carousel/quote-carousel';
//styles
import 'bootstrap/dist/css/bootstrap.css';
//media
import header_icon from '../media/industry/aircheckr-h&o-white.png';
import img_big from '../media/industry/ho-full-width.png';
//text
import { PageText, Categories, Quotes } from '../input-text/en/homeandoffice_page';

class HomeandOffice extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container'>
          <div className='col-sm-4 hidden-xs header-image-container'>
            <img src={header_icon} alt={'header_icon '+this.props.industry}/>
          </div>
          <div className='col-xs-12 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='2' category={ Categories._1 } />
        <section className="page-section">
            <div className="container">
                <QuoteCarousel quotes={ Quotes } />
            </div>
        </section>
        <CategoryContainer cols='1' category={ Categories._2 } />
        <SimpleContainer color='white' containerClass='big-image-container'>
          <img src={img_big} alt={'industry img big '+this.props.industry} />
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._3 } />
        <SimpleContainer color='white' containerClass='signup-strip padded-container'>
          <h1 className='signup-title'>{PageText._3}</h1>
          <p className='signup-text'>{PageText._4}</p>
          <Link to='/signup/' className="button">Sign up now</Link>
        </SimpleContainer>
      </div>
    );
  }
};

export default HomeandOffice;



// WEBPACK FOOTER //
// ./src/routes/HomeandOffice.js